import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from 'theme/Color';

const ContactFields = ({
  loading,
  fieldName,
  fieldValue,
  isChip = false,
  isProfile = false,
  src,
  icon,
}: {
  loading?: boolean;
  fieldName: string;
  fieldValue: string;
  isChip?: boolean;
  isProfile?: boolean;
  src?: string;
  icon: string;
}) => {
  return (
    <Box sx={{ display: 'flex', gap: '8px' }}>
      <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <img src={icon} alt={fieldName} width={20} height={20} />
        <Typography
          variant='responsiveBody3'
          sx={{ color: zeplinColor.Neutral8, minWidth: '10rem' }}
        >
          {fieldName}
        </Typography>
      </Box>
      {isProfile ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {src ? (
            <img
              src={src}
              alt={fieldName}
              style={{ borderRadius: '22px', width: '24px', height: '24px' }}
            />
          ) : (
            <Box
              sx={{
                borderRadius: '24px',

                width: { xs: '24px', xl: '24px' },
                height: { xs: '24px', xl: '24px' },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: zeplinColor.Brand1,
              }}
            >
              <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                {fieldValue
                  ?.split(' ')
                  .map((value: any, index: number) =>
                    fieldValue && (index === 0 || index === fieldValue?.split(' ').length - 1)
                      ? value[0]
                      : '',
                  )}
              </Typography>
            </Box>
          )}
          <Typography variant='responsiveBody2'>{fieldValue}</Typography>
        </Box>
      ) : isChip ? (
        <Chip
          label={
            <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
              Open
            </Typography>
          }
          sx={{
            backgroundColor: zeplinColor.BasicBlack,
            padding: '5px 12px 5px 12px',
            borderRadius: '50px',
            height: '24px',
            width: 'fit-content',
          }}
        />
      ) : (
        <Typography variant='responsiveBody2'>{fieldValue}</Typography>
      )}
    </Box>
  );
};

export default ContactFields;
